import { useTranslation } from "react-i18next";

import { Link } from "../lib/router";
import { ProfileAvatar } from "./ProfileAvatar";
import { useAppStore } from "../lib/store";
import { getThemeColors } from "../lib/theme";

export function AccountLink() {
  const auth = useAppStore((state) => state.auth);
  const name = useAppStore((state) => state.name);
  const isDark = useAppStore((state) => state.isDark);
  const theme = getThemeColors(isDark);
  const { t } = useTranslation();

  if (!auth) return null;

  if (auth.isAnonymous) {
    return (
      <Link
        to="/login"
        data-testid="sign-in-link"
        aria-label={t("login.signIn")}
        className={`flex h-11 items-center gap-2 rounded-xl border-[3px] border-ink shadow-board-sm press px-3 text-sm font-bold whitespace-nowrap ${theme.bgSecondary} ${theme.text}`}
      >
        <svg
          className="h-4 w-4 shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
          />
        </svg>
        {t("login.signIn")}
      </Link>
    );
  }

  return (
    <Link
      to="/account"
      data-testid="account-link"
      aria-label={t("account.open")}
      className={`flex h-11 max-w-44 items-center gap-2 rounded-xl border-[3px] border-ink shadow-board-sm press px-3 text-sm font-bold whitespace-nowrap ${theme.bgSecondary} ${theme.text}`}
    >
      <ProfileAvatar image={auth.image} name={auth.name} size="sm" />
      <span className="truncate">{name}</span>
    </Link>
  );
}
